(() => {
  window.LPMPreviewProfiles = window.LPMPreviewProfiles || {};

  /* =========================================================
     BIJOU DE SAC — CHAÎNE TROMBONE
     MODE 1 : GRAPPE
     Ordre des positions : du bas vers le haut
     ========================================================= */

  const bijouSacChaineTromboneClusterDesktopSlots = {
    0: [],

    1: [
      { x: 266, y: 490, r: 0 }
    ],

    2: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 446, r: -25 }
    ],

    3: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 446, r: -25 },
      { x: 230, y: 405, r: 35 }
    ],

    4: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 446, r: -25 },
      { x: 230, y: 405, r: 35 },
      { x: 294, y: 370, r: -25 }
    ],

    5: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 446, r: -25 },
      { x: 230, y: 405, r: 35 },
      { x: 294, y: 370, r: -25 },
      { x: 233, y: 320, r: 35 }
    ],

    6: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 446, r: -25 },
      { x: 230, y: 405, r: 35 },
      { x: 294, y: 370, r: -25 },
      { x: 233, y: 320, r: 35 },
      { x: 294, y: 280, r: -35 }
    ],

    7: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 446, r: -25 },
      { x: 230, y: 405, r: 35 },
      { x: 294, y: 370, r: -25 },
      { x: 233, y: 320, r: 35 },
      { x: 294, y: 280, r: -35 },
      { x: 230, y: 240, r: 25 }
    ],

    8: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 446, r: -25 },
      { x: 230, y: 405, r: 35 },
      { x: 294, y: 370, r: -25 },
      { x: 233, y: 320, r: 35 },
      { x: 294, y: 280, r: -35 },
      { x: 230, y: 240, r: 35 },
      { x: 293, y: 210, r: -35 }
    ]
  };

  const bijouSacChaineTromboneClusterMobileSlots = {
    0: [],

    1: [
      { x: 112, y: 311, r: 0 }
    ],

    2: [
      { x: 112, y: 311, r: 0 },
      { x: 142, y: 278, r: -40 }
    ],

    3: [
      { x: 112, y: 311, r: 0 },
      { x: 142, y: 278, r: -40 },
      { x: 80, y: 254, r: 35 }
    ],

    4: [
      { x: 112, y: 311, r: 0 },
      { x: 142, y: 278, r: -40 },
      { x: 80, y: 254, r: 35 },
      { x: 141, y: 229, r: -40 }
    ],

    5: [
      { x: 112, y: 311, r: 0 },
      { x: 142, y: 278, r: -40 },
      { x: 80, y: 254, r: 35 },
      { x: 141, y: 229, r: -40 },
      { x: 82, y: 196, r: 35 }
    ],

    6: [
      { x: 112, y: 311, r: 0 },
      { x: 142, y: 278, r: -40 },
      { x: 80, y: 254, r: 35 },
      { x: 141, y: 229, r: -40 },
      { x: 82, y: 196, r: 35 },
      { x: 145, y: 169, r: -45 }
    ],

    7: [
      { x: 112, y: 311, r: 0 },
      { x: 142, y: 278, r: -40 },
      { x: 80, y: 254, r: 35 },
      { x: 141, y: 229, r: -40 },
      { x: 82, y: 196, r: 35 },
      { x: 141, y: 169, r: -45 },
      { x: 79, y: 150, r: 35 }
    ],

    8: [
      { x: 112, y: 311, r: 0 },
      { x: 142, y: 278, r: -40 },
      { x: 80, y: 254, r: 35 },
      { x: 141, y: 229, r: -40 },
      { x: 82, y: 196, r: 35 },
      { x: 141, y: 169, r: -45 },
      { x: 79, y: 150, r: 35 },
      { x: 145, y: 122, r: -45 }
    ]
  };

  /* =========================================================
     MODE 2 : RÉPARTIS LE LONG DE LA CHAÎNE
     Base à calibrer finement
     Ordre des positions : du bas vers le haut
     ========================================================= */

  const bijouSacChaineTromboneDistributedDesktopSlots = {
    0: [],

    1: [
      { x: 266, y: 490, r: 0 }
    ],

    2: [
      { x: 266, y: 490, r: 0 },
      { x: 294, y: 370, r: -25 }
    ],

    3: [
      { x: 266, y: 490, r: 0 },
      { x: 296, y: 318, r: -28 },
      { x: 230, y: 180, r: 35 }
    ],

    4: [
      { x: 266, y: 490, r: 0 },
      { x: 230, y: 375, r: 28 },
      { x: 296, y: 300, r: -35 },
      { x: 230, y: 180, r: 35 }
    ],

    5: [
      { x: 266, y: 490, r: 0 },
      { x: 230, y: 405, r: 35 },
      { x: 296, y: 318, r: -28 },
      { x: 230, y: 258, r: 35 },
      { x: 296, y: 180, r: -35 }
    ],

    6: [
      { x: 266, y: 490, r: 0 },
      { x: 296, y: 432, r: -28 },
      { x: 230, y: 375, r: 28 },
      { x: 296, y: 318, r: -28 },
      { x: 230, y: 258, r: 28 },
      { x: 296, y: 198, r: -32 }
    ],

    7: [
      { x: 266, y: 490, r: 0 },
      { x: 235, y: 444, r: 28 },
      { x: 296, y: 405, r: -35 },
      { x: 230, y: 345, r: 35 },
      { x: 296, y: 290, r: -28 },
      { x: 233, y: 250, r: 28 },
      { x: 296, y: 180, r: -35 }
    ],

    8: [
      { x: 266, y: 490, r: 0 },
      { x: 235, y: 444, r: 28 },
      { x: 296, y: 405, r: -35 },
      { x: 230, y: 345, r: 35 },
      { x: 296, y: 290, r: -28 },
      { x: 230, y: 240, r: 35 },
      { x: 293, y: 210, r: -35 },
      { x: 230, y: 180, r: 35 }
    ]
  };

  const bijouSacChaineTromboneDistributedMobileSlots = {
  0: [],

  1: [
    { x: 112, y: 311, r: 0 }
  ],

  2: [
    { x: 112, y: 311, r: 0 },
    { x: 145, y: 229, r: -40 }
  ],

  3: [
    { x: 112, y: 311, r: 0 },
    { x: 145, y: 210, r: -40 },
    { x: 78, y: 100, r: 40 }
  ],

  4: [
    { x: 112, y: 311, r: 0 },
    { x: 80, y: 233, r: 35 },
    { x: 140, y: 170, r: -35 },
    { x: 78, y: 100, r: 40 }
  ],

  5: [
    { x: 112, y: 311, r: 0 },
    { x: 80, y: 254, r: 35 },
    { x: 140, y: 195, r: -35 },
    { x: 80, y: 150, r: 35 },
    { x: 145, y: 94, r: -45 }
  ],

  6: [
  { x: 112, y: 311, r: 0 },
  { x: 145, y: 268, r: -40 },
  { x: 80, y: 226, r: 45 },
  { x: 140, y: 184, r: -35 },
  { x: 80, y: 142, r: 35 },
  { x: 145, y: 94, r: -45 }
],

7: [
  { x: 112, y: 311, r: 0 },
  { x: 80, y: 275, r: 45 },
  { x: 145, y: 239, r: -40 },
  { x: 80, y: 203, r: 35 },
  { x: 140, y: 167, r: -35 },
  { x: 80, y: 131, r: 35 },
  { x: 145, y: 94, r: -45 }
],

8: [
  { x: 112, y: 311, r: 0 },
  { x: 145, y: 280, r: -40 },
  { x: 80, y: 249, r: 35 },
  { x: 140, y: 218, r: -35 },
  { x: 80, y: 187, r: 35 },
  { x: 145, y: 156, r: -40 },
  { x: 80, y: 125, r: 35 },
  { x: 145, y: 94, r: -45 }
]
};

  /* =========================================================
     PROFIL
     Fallback = grappe
     ========================================================= */

  window.LPMPreviewProfiles["bijou-sac-chaine-trombone"] = {
    desktop: bijouSacChaineTromboneClusterDesktopSlots,
    mobile: bijouSacChaineTromboneClusterMobileSlots,

    charmWidthDesktop: 115,
    charmWidthMobile: 105,
    mobileBreakpoint: 749,

    layouts: {
      cluster: {
        desktop: bijouSacChaineTromboneClusterDesktopSlots,
        mobile: bijouSacChaineTromboneClusterMobileSlots
      },

      distributed: {
        desktop: bijouSacChaineTromboneDistributedDesktopSlots,
        mobile: bijouSacChaineTromboneDistributedMobileSlots
      }
    }
  };
})();
